export default __webpack_public_path__ + "static/media/btn1.7c9fe1ca.webp";